var zh_CN_default = {
  "request.response_status_code.400": "\u8BF7\u6C42\u9519\u8BEF",
  "request.response_status_code.401": "\u672A\u6388\u6743\uFF0C\u8BF7\u767B\u5F55",
  "request.response_status_code.403": "\u62D2\u7EDD\u8BBF\u95EE",
  "request.response_status_code.404": "\u8BF7\u6C42\u5730\u5740\u51FA\u9519",
  "request.response_status_code.408": "\u8BF7\u6C42\u8D85\u65F6",
  "request.response_status_code.500": "\u670D\u52A1\u5668\u5185\u90E8\u9519\u8BEF",
  "request.response_status_code.502": "\u7F51\u5173\u9519\u8BEF",
  "request.response_status_code.503": "\u670D\u52A1\u4E0D\u53EF\u7528",
  "request.response_status_code.504": "\u7F51\u5173\u8D85\u65F6",
  "request.response_status_code.other": "\u8FDE\u63A5\u51FA\u9519",
  "request.no_response": "\u8FDE\u63A5\u51FA\u9519",
  "request.error": "\u8BF7\u6C42\u9519\u8BEF",
  "login.btn.login": "\u767B\u5F55",
  "login.btn.logout": "\u9000\u51FA",
  "login.btn.forgot_password": "\u5FD8\u8BB0\u5BC6\u7801",
  "login.btn.edit_password": "\u4FEE\u6539\u5BC6\u7801",
  "login.captcha.phone": "\u624B\u673A\u53F7",
  "login.captcha.email": "\u90AE\u7BB1",
  "login.placeholder.phone": "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
  "login.placeholder.email": "\u8BF7\u8F93\u5165\u90AE\u7BB1",
  "login.type.account": "\u8D26\u53F7\u767B\u5F55",
  "login.type.captcha": "\u9A8C\u8BC1\u7801\u767B\u5F55",
  "login.type.feishu": "\u98DE\u4E66\u767B\u5F55",
  "login.input.required": "\u8BF7\u8F93\u5165",
  "login.password.mismatch": "\u60A8\u8F93\u5165\u7684\u4E24\u4E2A\u5BC6\u7801\u4E0D\u5339\u914D!",
  "login.password.required": "\u8BF7\u8F93\u5165\u5BC6\u7801",
  "login.verification.required": "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
  "login.verification.placeholder": "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
  "login.verification.get": "\u83B7\u53D6\u9A8C\u8BC1\u7801",
  "login.password.confirm.required": "\u8BF7\u8F93\u5165\u786E\u8BA4\u5BC6\u7801",
  "login.password.confirm.placeholder": "\u8BF7\u8F93\u5165\u786E\u8BA4\u5BC6\u7801",
  "login.submit": "\u63D0\u4EA4",
  "login.password.new.placeholder": "\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801",
  "login.password.new.confirm.placeholder": "\u8BF7\u8F93\u5165\u786E\u8BA4\u65B0\u5BC6\u7801",
  "login.back": "\u8FD4\u56DE\u767B\u5F55",
  "login.phoneNumber.required": "\u8BF7\u8F93\u5165\u624B\u673A\u53F7"
};
export {
  zh_CN_default as default
};
